import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useThemeContext } from "../hooks/useThemeContext";

const ThemeToggleButton = () => {
  const { toggleTheme, isDarkMode } = useThemeContext();
  // const theme = useTheme();

  return (
    <Tooltip title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}>
      <IconButton
        onClick={toggleTheme}
        size="medium"
        sx={{
          color: "inherit",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "rotate(20deg)",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
      >
        {isDarkMode ? (
          <Brightness7Icon sx={{ color: "#FBBF24", fontSize: 22 }} />
        ) : (
          <Brightness4Icon sx={{ color: "#FFD700", fontSize: 22 }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;